import { React, useState, useRef, useEffect } from "react";
const TennisScoreBoard = ({ eventDetails, scoreboardData }) => {
  const [homeName, setHomeName] = useState("");
  const [awayName, setAwayName] = useState("");
  const [currentSet, setCurrentSet] = useState("");
  const [hour, setHour] = useState(0);
  const [minut, setMinut] = useState(0);

  const [homePoint, setHomePoint] = useState(0);
  const [awayPoint, setAwayPoint] = useState(0);

  const [homeGameSequence, setHomeGameSequence] = useState([]);
  const [awayGameSequence, setAwayGameSequence] = useState([]);
  const [loopCount, setLoopCount] = useState(0);

  const setScoreBoardData = async (scoreboardData) => {
    console.log("scoreboardData Tennis->", scoreboardData);

    if (scoreboardData !== null && scoreboardData !== undefined) {
      let data = scoreboardData;

      let scoreData = data[0]?.score;
      if (data[0]?.currentSet !== undefined) {
        setCurrentSet(data[0]?.currentSet);
      }

      if (scoreData?.home?.name !== undefined) {
        setHomeName(scoreData?.home?.name);
      }
      if (scoreData?.away?.name !== undefined) {
        setAwayName(scoreData?.away?.name);
      }

      if (data[0]?.fullTimeElapsed?.hour !== undefined) {
        setHour(data[0]?.fullTimeElapsed?.hour);
      }

      if (data[0]?.fullTimeElapsed?.min !== undefined) {
        setMinut(data[0]?.fullTimeElapsed?.min);
      }

      if (data[0]?.score?.home?.gameSequence !== undefined) {
        let homeSqe = data[0]?.score?.home?.gameSequence;
        homeSqe.push(data[0]?.score?.home?.games);
        setHomeGameSequence(homeSqe);
      }

      if (data[0]?.score?.away?.gameSequence !== undefined) {
        let awaySqe = data[0]?.score?.away?.gameSequence;
        awaySqe.push(data[0]?.score?.away?.games);
        setAwayGameSequence(awaySqe);
      }

      setHomePoint(data[0]?.score?.home?.score);
      setAwayPoint(data[0]?.score?.away?.score);

      if (data[0]?.currentSet == null || data[0]?.currentSet == undefined) {
        setLoopCount(3);
      } else {
        setLoopCount(data[0]?.currentSet);
      }
    }
  };

  useEffect(() => {
    setScoreBoardData(scoreboardData);
  }, [scoreboardData]);

  return (
    <div className="row bg-gray-100 market-head" style={{ width: "100%" }}>
      <style>
        {`
 .scores {
  background-color: white;
  border: 0px solid black;
  padding: 0.25rem;
  border-bottom: 1px solid black;
}
.scores .runnername {
  margin-top: 7px; 
  color: black;
  font-size: 15px;
}
.scores .runner-score {
  color: black;
  font-size: 18px;
  margin-top: 2px;
  padding: 0px;
}
.colwidthset {
  width: 1vw;
}
.colwidthset {
  width: 1vw;
}
.scores .col-divider {
  border-left: 1px solid black;
}
.scores .active {
  color: #009069;
}
.scores .col-divider {
  border-left: 1px solid black;
}
  .scores .runner-score {
  color: black;
  font-size: 18px;
  margin-top: 2px;
  padding: 0px;
}
.scores .col-divider {
  border-left: 1px solid black;
}
.scores .active {
  color: #009069;
}
        `}{" "}
      </style>

      <div class="scores" style={{ width: "100%" }}>
        <div class="row" style={{ margin: "0px", padding: "2px" }}>
          <div class="col-4" style={{ lineHeight: "0", padding: "0px" }}>
            <p class="runnername site_family">
              <b>{homeName}</b>
            </p>{" "}
            <p class="runnername site_family">
              <b>{awayName}</b>
            </p>{" "}
            <span
              style={{ lineHeight: "0.4", color: "rgb(0, 177, 129)" }}
              className="site_family"
            >
              Set {currentSet} |
            </span>{" "}
            <span
              class="sethourshow"
              style={{ color: "rgb(0, 177, 129)" }}
              className="site_family"
            >
              {hour}:{minut}
            </span>
          </div>{" "}
          <div
            class="col-8"
            style={{ textAlign: "center", lineHeight: "1", padding: "0px" }}
          >
            <table
              class="col-12 table-responsive-sm tableresp site_family"
              border="0"
            >
              <tbody id="tennisScoreCard">
                <tr>
                  {homeGameSequence.map((num, index) => (
                    <td class="runner-score colwidthset active">{num}</td>
                  ))}

                  <td class="runner-score active col-divider colwidthset">
                    {homePoint}
                  </td>

                  <td class="runner-score col-divider colwidthset">0</td>
                </tr>
                <tr>
                  {awayGameSequence.map((num, index) => (
                    <td class="runner-score colwidthset active">{num}</td>
                  ))}

                  <td class="runner-score active col-divider colwidthset">
                    {awayPoint}
                  </td>

                  <td class="runner-score active col-divider colwidthset">0</td>
                </tr>
                <tr class="col-12 tablefotercs">
                  {Array.from({ length: loopCount }, (_, i) => (
                    <td class="colwidthset active">{i + 1}</td>
                  ))}

                  <td class="col-divider colwidthset">Points</td>
                  <td class=" col-dividerlrhom col-divider colwidthset">
                    ServBreak
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TennisScoreBoard;
